module.exports = __webpack_public_path__ + "img/ic_bg_car.458ac56e.png";